var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from 'react'; // tslint:disable-line

import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('grid');
import { get } from 'lodash';
import { breakpoints, theme } from '@shapeable/theme';
export var GridDefaultProps = {
  className: '',
  columns: 0,
  maxColumns: 6,
  minColumns: 1,
  spacing: 0,
  items: [],
  itemKeys: [],
  tabletAutoColumns: 2,
  desktopAutoColumns: 4
}; // -------- Styles -------->

var GridContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: 0;\n  "], ["\n    min-width: 0;\n  "]))),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-wrap: wrap;\n    display: flex;\n  "], ["\n    flex-wrap: wrap;\n    display: flex;\n  "]))),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-wrap: wrap;\n    display: flex;\n  "], ["\n    flex-wrap: wrap;\n    display: flex;\n  "])))
});

var oneColumnPatch = function oneColumnPatch(props) {
  return props.columns === 1 && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-right: none; padding-right: 0; width: 100%;\n"], ["\n  border-right: none; padding-right: 0; width: 100%;\n"])));
};

var calcFor = function calcFor(space, columns) {
  // to make the final column align to the end, the width we use isn't just a simple ((100 * 1/n) - space) calc, but rather must dedcut space which would leave (n-1) gutters only. 
  var spaceToDeduct = (columns - 1) / columns * (space * 4);
  return "calc(" + 1 / columns * 100 + "% - " + spaceToDeduct + "px)";
};

var GridItemStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    box-sizing: content-box;\n    padding-bottom: ", ";\n  "], ["\n    box-sizing: content-box;\n    padding-bottom: ", ";\n  "])), function (props) {
    return props.last || props.buffer ? 0 : theme.UNIT(props.space);
  }),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    border-top: none;\n\n    ", "\n\n  "], ["\n    border-top: none;\n\n    ", "\n\n  "])), function (props) {
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      width: ", ";\n      padding-bottom: ", ";\n      padding-right: ", ";\n\n      &:nth-child(", "n) {\n        margin-right: -", ";\n      }\n    "], ["\n      width: ", ";\n      padding-bottom: ", ";\n      padding-right: ", ";\n\n      &:nth-child(", "n) {\n        margin-right: -", ";\n      }\n    "])), calcFor(props.space, props.columns === 0 ? props.tabletAutoColumns : props.columns), theme.UNIT(props.space), theme.UNIT(props.space), props.columns === 0 ? props.tabletAutoColumns : props.columns, theme.UNIT(props.space));
  }),
  desktop: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", "\n    \n    ", ";\n  "], ["\n    ", "\n    \n    ", ";\n  "])), function (props) {
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      width: ", ";\n\n      &:nth-child(2n),\n      &:nth-child(3n) {\n        margin-right: 0;\n      }\n    \n      &:nth-child(", "n) {\n        margin-right: -", ";\n      }\n    "], ["\n      width: ", ";\n\n      &:nth-child(2n),\n      &:nth-child(3n) {\n        margin-right: 0;\n      }\n    \n      &:nth-child(", "n) {\n        margin-right: -", ";\n      }\n    "])), calcFor(props.space, props.columns === 0 ? props.desktopAutoColumns : props.columns), props.columns === 0 ? props.desktopAutoColumns : props.columns, theme.UNIT(props.space));
  }, oneColumnPatch)
}); // -------- Components -------->

var GridContainer = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), GridContainerStyles);
var GridItem = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), GridItemStyles);
export var Grid = function Grid(props) {
  var className = props.className,
      items = props.items,
      itemKeys = props.itemKeys,
      columns = props.columns,
      minColumns = props.minColumns,
      empty = props.empty,
      spacing = props.spacing;
  var desktopMinColumns = props.desktopMinColumns || props.desktopAutoColumns;
  var tabletMinColumns = props.tabletMinColumns || props.tabletAutoColumns; // determine size

  var size = columns;

  if (size === 0) {
    size = items.length % 2 === 0 ? 2 : Math.min(3, Math.max(1, items.length));
  } // auto columns should only be honored if there are at least that many items


  var tabletAutoColumns = Math.min(props.maxColumns, Math.max(minColumns, tabletMinColumns, Math.min(props.tabletAutoColumns, items.length)));
  var desktopAutoColumns = Math.min(props.maxColumns, Math.max(minColumns, desktopMinColumns, Math.min(props.desktopAutoColumns, items.length))); // @ts-ignore

  var Container = GridContainer;
  var gridItems = items.map(function (item, i) {
    var lastRow = i >= items.length - (columns - items.length % columns);
    return React.createElement(GridItem, {
      className: cls.sub('item'),
      tabletAutoColumns: tabletAutoColumns,
      desktopAutoColumns: desktopAutoColumns,
      lastRow: lastRow,
      space: spacing,
      columns: columns,
      key: get(itemKeys, i) || "item" + i,
      last: i === items.length - 1
    }, item);
  });

  if (items.length === 0 && Boolean(empty)) {
    return empty;
  }

  ;
  return React.createElement(Container, {
    className: cls.name(className)
  }, gridItems);
};
Grid.defaultProps = GridDefaultProps;
Grid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;